var App = App || {};

App.MyEmailAlerts = (function ($) {
    var alertId, updateFor, hasManyAlerts;
    return {
        init: init,
        getActivityAlertModal: getActivityAlertModal,
    };

    function init() {
        initializeEmailAlertsWrap();
        initializeGloablModalContent();
        initializeAlertsWidget();
        initializeActivityAlertsModal();
        initializeAlertFrequencyDropdown();
    }

    function initializeAlertFrequencyDropdown() {
        var $emailAlertsWrap = $('.js-email-alerts-wrap');
        if ($emailAlertsWrap.length) {
            $emailAlertsWrap.on('change', '.js-alert-frequency-select', updateAlert);
        }
    }

    function updateAlert($alertFrequencyDropdown, newAlertName, alertRowHasMultipleAlerts) {
        if (!$alertFrequencyDropdown.length) {
            $alertFrequencyDropdown = $(this);

        }
        if (!$alertFrequencyDropdown.length) {
            return;
        }
        swapAlertsWrapCover();

        var postData = {
            NewScheduleId: $alertFrequencyDropdown.val(),
            NewAlertName: newAlertName,
            AlertIdToReschedule: $alertFrequencyDropdown.data('alert-id'),
            HasMultipleAlerts: alertRowHasMultipleAlerts,
            UpdateFor: $alertFrequencyDropdown.data('update-for'),
            ConfigSiteName: ($('input#Config_ConfigurableSiteName').length) ? $('input#Config_ConfigurableSiteName').val() : "",
            SeparateJournalsAlerts: ($('input#Config_SeparateJournalsAlerts').length) ? $('input#Config_SeparateJournalsAlerts').val() : false,
            EmailAlertsAuthToken: $('#EmailAlertsAuthToken').val(),
            ShowSyncOnlyAlerts: ($('input#Config_SeparateJournalsAlerts').length) ? $('input#Config_ShowSyncOnlyAlerts').val() : false
        };

        var ajaxUrl = '//' + SCM.SearchResults.defaults.baseSiteUrl + '/Content/MyEmailAlerts';
        SCM.Ajax.post(ajaxUrl, postData)
            .then(function (result) {
                updateEmailAlertsAuthToken(result);
                updateNewJournalIssuesAlerts(result);
            })
            .catch(function (error) {
                console.error('Updating alert frequency has an error: ' + error);
            })
            .finally(function () {
                swapAlertsWrapCover();
            });
    }

    function initializeEmailAlertsWrap() {
        var $emailAlertsWrap = $('.js-email-alerts-wrap');
        if ($emailAlertsWrap.length) {
            $emailAlertsWrap.on('click', '.js-delete-email-alert', openModal);
            $emailAlertsWrap.on('click', '.js-add-new-journal-issues-alert', redirectToNewJournalIssuesPage);
            $emailAlertsWrap.on('click', '.js-rename-email-alert', displayAlertRenameInterface);
            $emailAlertsWrap.on('click', '.js-save-alert-rename-cancel', cancelAlertRename);
            $emailAlertsWrap.on('click', '.js-save-alert-rename-save', saveAlertRename);
        }
    }

    function initializeGloablModalContent() {
        var $globalModalContent = $('#globalModalContent');
        if ($globalModalContent.length) {
            $globalModalContent.on('click', '.js-delete-email-alert-modal-ok', deleteEmailAlert);
        }
    }

    function initializeAlertsWidget() {
        var $alertsWidget = $('.js-alerts-widget');
        if ($alertsWidget.length) {
            $alertsWidget.on('click', '.js-my-email-alert', myEmailAlertClick);
            $alertsWidget.on('click', '.js-activity-alert-button', getActivityAlertModal);
        }
    }

    function initializeActivityAlertsModal() {
        var $activityAlertModal = $('#activityAlertModal');
        if ($activityAlertModal.length) {
            $activityAlertModal.on('click', '.js-close-reveal-modal', closeActivityModal);
            $activityAlertModal.on('click', '.js-save-activity-alert', saveContentActivityAlert);

            $(document).on('click', '.reveal-modal-bg', closeActivityModal);
        }
    }

    function saveContentActivityAlert() {
        var $userAlertLink = $(this);
        var $activityModal = $userAlertLink.closest('#activityAlertModal');
       
        var selectedActivities = [];
        $activityModal.find('.js-activity-modal-checkbox-list .chkSelect:checked').each(function () {
            selectedActivities.push($(this).data('id'));
        });

        var postData = {
            resourceId: $userAlertLink.data('resourceid'),
            resourceType: $userAlertLink.data('resourcetypeid'),
            activityIds: selectedActivities,
            frequencyId: $activityModal.find('.js-activity-alert-frequency-ddl').val(),
        };

        var ajaxUrl = '//' + SCM.SearchResults.defaults.baseSiteUrl + '/AlertSignUp/CreateNewContentActivityAlert';
        SCM.Ajax.post(ajaxUrl, postData)
            .expectJson()
            .then((response) => {
                if (response.Success) {
                    showSuccessMessageActivityModal();
                }
            })
            .catch(function (error) {
                console.error('Saving alert has an error: ' + error);
            });
    }

    function openModal() {
        alertId = $(this).data('alert-id');
        updateFor = $(this).data('update-for');
        hasManyAlerts = $(this).data('has-many-alerts');
    }

    function myEmailAlertClick() {
        var $userAlert = $(this);
        var marketingUrl = $userAlert.data('marketing-url');
        var isContentPage = $userAlert.data('is-content-page');
        var alertSignUpLink = $userAlert.data('alert-signup-link');

        resetJournalIssuesAlertModal();

        if (marketingUrl && marketingUrl.length) {
            window.location = marketingUrl;
        }
        else if (isContentPage.toLowerCase() === 'false') {
            window.location = alertSignUpLink;
        }
    }

    function resetJournalIssuesAlertModal() {
        $('.failure-alert-message').addClass('hidden');
        $('.success-alert-message').addClass('hidden');
        $('.js-journalsIssuesAlertBody').removeClass('hidden');
        $('.js-journalsIssuesAlertFooter').removeClass('hidden');
    }

    function deleteEmailAlert() {
        SCM.Modals.closeModal();
        swapAlertsWrapCover();

        var modelValues = {
            AlertIdToDelete: alertId,
            UpdateFor: updateFor,
            HasMultipleAlerts: hasManyAlerts,
            SeparateJournalsAlerts: ($('input#Config_SeparateJournalsAlerts').length) ? $('input#Config_SeparateJournalsAlerts').val() : false,
            EmailAlertsAuthToken: $('#EmailAlertsAuthToken').val()
        };

        SCM.Ajax.post('/Content/MyEmailAlerts', modelValues)
            .then(function (result) {
                if (result) {
                    updateEmailAlertsAuthToken(result);
                    updateNewJournalIssuesAlerts(result);
                }
            })
            .catch(function (reason) {
                console.error('Deleting the alert has an error: ' + reason);
            })
            .finally(function () {
                swapAlertsWrapCover();
            });
    }

    function redirectToNewJournalIssuesPage() {
        window.location.href = $(this).data('redirect-url');
    }

    function swapAlertsWrapCover() {
        $('.alerts-wrap-cover').toggleClass('uncovered');
        $('.alerts-wrap-cover').toggleClass('covered');
    }

    function updateEmailAlertsAuthToken(result) {
        var emailAlertsAuthToken = $(result).find('#EmailAlertsAuthToken').val();
        if (emailAlertsAuthToken) {
            $('#EmailAlertsAuthToken').val(emailAlertsAuthToken);
        }
    }

    function updateNewJournalIssuesAlerts(result) {
        var journalsAlertList = $(result).find('div#journalsDetails').html();
        if (journalsAlertList && journalsAlertList.length) {
            $('div#journalsDetails').html(journalsAlertList);
        }
    }

    function showSuccessMessageActivityModal() {
        $('.success-alert-message').removeClass('hidden');
        $('#js-activity-alert-body').addClass('hidden');
        $('#js-activity-alert-footer').addClass('hidden');
    }

    function closeActivityModal() {
        var $button = $('.js-activity-alert-button');

        if ($button.length) {
            $button.attr('aria-expanded', false);
            $('.success-alert-message').addClass('hidden');
            $('#js-activity-alert-body').removeClass('hidden');
            $('#js-activity-alert-footer').removeClass('hidden');
        }
    }

    function getActivityAlertModal() {
        var $button = $('.js-activity-alert-button');
        if ($button) {
            $button.attr('aria-expanded', true);

            var ajaxUrl = '//' + SCM.SearchResults.defaults.baseSiteUrl + '/AlertSignUp/ActivityAlert';
            var data = {
                resourceId: $button.data('resourceid'),
                resourceType: $button.data('resourcetypeid')
            };
            SCM.Ajax.get(ajaxUrl, data)
                .then((response) => {
                    $('.js-activity-alert-widget').html(response);
                })
                .catch(function (error) {
                    console.error('Retrieving activity alert modal has an error: ' + error);
                });
        }
    }

    function saveAlertRename() {
        var $parentElemRow = $(this).closest('tr');

        if ($parentElemRow.length) {
            var $searchNameInput = $parentElemRow.find('.js-save-alert-name-input');
            var newSearchName = $searchNameInput.val();
            var alertRowHasMultipleAlerts = $parentElemRow.find('.js-rename-email-alert').data('has-many-alerts');;
            var $alertFrequencyDropdown = $parentElemRow.find('.js-alert-frequency-select');
            if ($alertFrequencyDropdown.length){
                updateAlert($alertFrequencyDropdown, newSearchName, alertRowHasMultipleAlerts);
            }
        }
    }

    function displayAlertRenameInterface() {
        var $parentElemRow = $(this).closest('tr');
        var $alertName = $parentElemRow.find('.js-search-alert-name');
        
        if ($alertName.length)
        {
            $alertName.addClass('hidden');
            $alertNameInput = $parentElemRow.find('.js-save-alert-name-input');
            if ($alertNameInput.length) {
                var alertOriginalName = $alertName.data('original-name') ?? $alertName.text();
                $alertNameInput.val(alertOriginalName);
                $alertNameInput.addClass('save-alert-name-input');
                $alertNameInput.focus();
            }
            $parentElemRow.find('.js-save-alert-rename-cancel').removeClass('hidden');
            $parentElemRow.find('.js-save-alert-rename-save').removeClass('hidden');
        }
    }

    function cancelAlertRename() {
        var $parentElemRow = $(this).closest('tr');

        if ($parentElemRow.length)
        {
            $parentElemRow.find('.js-save-alert-name-input').removeClass('save-alert-name-input');
            $parentElemRow.find('.js-save-alert-rename-cancel').addClass('hidden');
            $parentElemRow.find('.js-save-alert-rename-save').addClass('hidden');
            $parentElemRow.find('.js-search-alert-name').removeClass('hidden');
        }
    }

})(jQuery);